import React, { MutableRefObject, Ref } from 'react'
import {
  ThemeProvider,
  ToggleButton,
  ToggleButtonGroup,
  createTheme
} from '@mui/material'
import { theme } from 'theme'
import { APP_COLOR } from 'utils/colors'

export interface SegmentItem {
  value: any
  title: string
}

export interface SegmentButtonProps {
  items: SegmentItem[]
  selected?: SegmentItem
  onSelect: (segmentItem: SegmentItem) => void
  width?: string
}

const cornerRadius = '8px'

const segmentTheme = createTheme({
  components: {
    MuiToggleButton: {
      styleOverrides: {
        root: {
          '&.Mui-selected': {
            backgroundColor: APP_COLOR,
            color: 'black',
            '&:hover': {
              backgroundColor: APP_COLOR
            }
          }
        }
      }
    }
  }
})

export default function SegmentButton(props: SegmentButtonProps) {
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newValue: string
  ) => {
    const newItem = props.items.find((item) => item.value === newValue)
    if (newItem) props.onSelect(newItem)
  }

  const buttonSX = (index: number) => ({
    flex: 1,

    ...(index === 0 && {
      borderTopLeftRadius: cornerRadius,
      borderBottomLeftRadius: cornerRadius
    }),
    ...(index === props.items.length - 1 && {
      borderTopRightRadius: cornerRadius,
      borderBottomRightRadius: cornerRadius
    })
  })

  return (
    <ThemeProvider theme={segmentTheme}>
      {props.items.length > 0 ? (
        <ToggleButtonGroup
          sx={{
            width: props.width ?? 'auto',
            height: '30px',
            display: 'flex'
          }}
          value={props.selected?.value}
          exclusive
          onChange={handleChange}
        >
          {props.items.map((item, index) => {
            return (
              <ToggleButton
                key={item.value}
                sx={{
                  ...buttonSX(index),
                  textTransform: 'none',
                  color:
                    item.value === props.selected?.value ? 'white' : 'black',
                  '&.Mui-selected, &.Mui-selected:hover': {
                    color: 'white'
                  }
                }}
                value={item.value}
              >
                {item.title.toLowerCase()}
              </ToggleButton>
            )
          })}
        </ToggleButtonGroup>
      ) : (
        <>No items</>
      )}
    </ThemeProvider>
  )
}
